import {FC} from 'react';
interface Props {
    type: 'success' | 'error'
}

const Animation: FC<Props> = ({ type }) => {
    const isError = type === 'error';

    return (
        <>
            <div className={` w-20 h-20 rounded-full flex items-center justify-center ${isError ? 'bg-red-500' : 'bg-green-500'}`}
            >
                {isError ? (
                    <svg className="w-12 h-12 text-white" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"
                         fill="none"
                         stroke="currentColor" strokeWidth="3">
                        <line x1="18" y1="6" x2="6" y2="18"></line>
                        <line x1="6" y1="6" x2="18" y2="18"></line>
                    </svg>
                ) : (
                    <svg className="w-12 h-12 text-white" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"
                         fill="none"
                         stroke="currentColor" strokeWidth="3">
                        <polyline points="20 6 9 17 4 12"></polyline>
                    </svg>
                )}
            </div>
        </>
    );
};

export default Animation;
